<template>
    <div class="shop heart" v-if="heartBool">
        <div class="shop-cart">
            <img @click="$emit('heartFalse', false)" class="shop-cart__close" src="../../assets/img/close.svg">
            <h2 class="shop-cart__title">Saqlangan</h2>
            <hr>
            <div class="heart__saved">
                <div class="heart__saved-card" v-for="item in heart" :key="item">
                    <img class="heart__saved-card__img" :src="item.img" alt="">
                    <div class="heart__saved-card__info">
                        <h4>{{item.title}}</h4>
                        <p><span>{{item.price}}</span> sum</p>
                    </div>
                    <img @click="$emit('delHeart',item.id)" class="heart__saved-card__heart" src="../../assets/img/hart.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        heart:Array,
        heartBool:Boolean
    },
    data() {
        return {
            
        }
    },
}
</script>
<style lang="scss">
    .heart{
        &__saved{
            margin-top: 10px;
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            justify-content: space-between;
            &-card{
                width: 48%;
                border: 1px solid #333333c2;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                box-shadow: 5px 5px 1px #333333c2;
                transition: 0.3s;
                transition-timing-function: ease-in;
                border-radius: 5px;
                cursor: pointer;
                position: relative;
                &:hover{
                    box-shadow: none;
                }
                &__img{
                    width: 30%;
                }
                &__info{
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                }
                &__heart{
                    width: max-content;
                    height: 30px;
                    position: absolute;
                    top: -10px;
                    right: 0;
                    background: #ff0000;
                    padding: 6px;
                    border-radius: 5px;
                }
            }
        }
    }
</style>